@if (mostraMenu) {
  <button mat-icon-button [matMenuTriggerFor]="menu" class="btn-notifica">
    <mat-icon matBadge="!" matBadgeOverlap="false" matBadgeColor="warn" [matBadgeHidden]="!menuMan">
      notifications_active
    </mat-icon>
  </button>
}

<mat-menu #menu="matMenu" xPosition="before">
  <div mat-menu-item>
    <app-banner-manutenzione
      (manutenzioneAttiva)="isManutenzione($event)"
    ></app-banner-manutenzione>
  </div>
</mat-menu>
